<template>
    <div class="container-fluid">
        <h1>Project Status Page</h1>

        <font-awesome-icon icon="sync" spin v-if="loading"/>

        <div class="alert alert-danger" role="alert" v-if="hasError">
            <b>Fehler</b><br>
            Daten konnten nicht geladen werden!
        </div>

        <div class="row">
            <div v-bind:class="['col-sm-'+(12/projectsPerRow)]" class="" v-for="project in projects"
                 v-if="project.status.nextRedmineId > 0 || project.status.currentRedmineId > 0">
                <div class="card margin-top">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-6">
                                <h5><img height="25" v-bind:src="'/static/' + project.logo" v-bind:alt="project.name">
                                    {{project.name}}
                                    <font-awesome-icon icon="sync" spin v-if="project.loading"/>
                                </h5>
                            </div>
                            <div class="col-6 text-right">
                                <span v-if="project.status.currentRedmineId > 0 && project.status.isCurrentMergedInMaster === false"
                                      class="badge badge-danger">Not merged</span>
                                <span v-if="project.status.isMaintenanceMode === true" class="badge badge-danger">Maintenance</span>
                                <span v-if="project.status.isCronPaused === true"
                                      class="badge badge-warning">Cron paused</span>
                                <span v-if="project.status.isCurrentUpdateRunning === true" class="badge badge-success">Update running</span>
                            </div>
                        </div>

                    </div>
                    <div class="card-body project-content">
                        <div class="alert alert-warning" role="alert"
                             v-if="project.status.nextRedmineId == 0 && project.status.currentRedmineId == 0">
                            <b>Warnung:</b>
                            Keine Informationen gefunden!
                        </div>
                        <div class="row">
                            <div class="col-6" v-if="project.status.isMaintenanceMode === true">
                                <button v-on:click="deactivateMaintenanceMode(project)"
                                        type="button" class="btn btn-danger">Disable Maintenance!
                                </button>
                            </div>
                            <div class="col-6" v-if="project.status.isCronPaused === true">
                                <button v-on:click="deactivateCronPause(project)"
                                        type="button" class="btn btn-danger">Disable cron-pause!
                                </button>
                            </div>
                        </div>
                        <div class="row" v-if="project.status.nextRedmineId > 0 || project.status.currentRedmineId > 0">
                            <div class="col-lg-6" v-if="project.status.currentRedmineId > 0">
                                Current: <a target="_blank"
                                            v-bind:href="'https://redmine.etailer.de/issues/' + project.status.currentRedmineId">{{project.status.currentRedmineId}}</a>

                                <div>
                                    <button v-if="project.status.isCurrentMergedInMaster === false"
                                            type="button"
                                            class="btn btn-secondary" disabled>Please merge first!
                                    </button>
                                    <button v-if="project.status.isCurrentUpToDate === true"
                                            type="button" class="btn btn-success" disabled>Is Up-do-date
                                    </button>
                                    <button v-if="!project.status.isCurrentUpToDate && project.status.isCurrentMergedInMaster === true && project.status.currentRedmineId > 0"
                                            v-on:click="updateCurrent(project)"
                                            type="button" class="btn btn-success">Update current
                                    </button>
                                </div>
                            </div>
                            <div class="col-lg-6" v-if="project.status.nextRedmineId > 0">
                                Next: <a target="_blank"
                                         v-bind:href="'https://redmine.etailer.de/issues/' + project.status.nextRedmineId">{{project.status.nextRedmineId}}</a>
                                <div v-if="project.status.isNextCustomerVerified === false">
                                    <button
                                            type="button"
                                            class="btn btn-secondary" disabled>Not customer-verified!
                                    </button>
                                </div>
                                <div v-if="project.status.isNextCustomerVerified">
                                    <button
                                            type="button"
                                            class="btn btn-success"
                                            v-on:click="updateNext(project)">
                                        Update next
                                    </button>
                                </div>

                                <div v-if="project.status.currentRedmineId > 0 && project.status.nextRedmineId > 0">
                                    <br>
                                    <router-link
                                            :to="{ name: 'ChangeListParams', params: { from: 'release/'+project.status.currentRedmineId, to: 'release/'+project.status.nextRedmineId, project: project.identifier }}">
                                        Changelog
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer text-muted">
                        <div class="row">
                            <div class="col-6">
                                Last refresh: {{project.status.refreshedDateAndTime}}
                            </div>
                            <div class="col-6 text-right">
                                <button type="button" class="btn btn-outline-secondary btn-sm"
                                        v-on:click="getProjectStatus(project)">Refresh now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card border-danger margin-top" v-if="unmergedProjects.length > 0">
            <div class="card-header">
                Not merged projects
            </div>
            <div class="card-body">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th>Kunde</th>
                        <th>Branch / Redmine</th>
                        <th>Gitlab core</th>
                        <th>Gitlab customer</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="unmergedProject in unmergedProjects">
                        <th>{{unmergedProject.name}}</th>
                        <td>
                            <a target="_blank"
                               v-bind:href="'https://redmine.etailer.de/issues/' + unmergedProject.status.currentRedmineId">{{unmergedProject.status.currentRedmineId}}</a>
                        </td>
                        <td>
                            <a target="_blank"
                               v-bind:href="'https://gitlab.etailer.de/etailer/core/branches/all?utf8=%E2%9C%93&search=' + unmergedProject.status.currentRedmineId">Link</a>
                        </td>
                        <td>
                            <a target="_blank"
                               v-bind:href="'https://gitlab.etailer.de/'+getCustomerName(unmergedProject.identifier)+'/customer_'+getCustomerName(unmergedProject.identifier)+'/branches/all?utf8=%E2%9C%93&search=' + unmergedProject.status.currentRedmineId">Link</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="card border-info margin-top margin-bottom">
            <div class="card-header">
                Logs
            </div>
            <div class="card-body">
                <ul>
                    <li v-for="log in logs">{{log.timestamp}}: {{log.message}}</li>
                </ul>
            </div>
        </div>


    </div>
</template>

<script>
  import Api from '../Api'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

  export default {
    name: 'project-status-page',
    components: {
      FontAwesomeIcon
    },
    methods: {
      getProjectStatus (project) {
        project.loading = true
        Api.getProjectStatus(project.identifier).then((status) => {
          project.status = status
          project.loading = false
        }).catch((err) => {
          if (err === 'FAILD') {
            project.loading = false
          } else if (err === 'UNAUTHORIZED') {
            this.$router.push('/login')
          }
        })
      },
      getCustomerName (customerIdentifier) {
        if (customerIdentifier === 'gudrun-sjoeden') {
          return 'gudrunsjoeden'
        }
        if (customerIdentifier === 'applicas-nette-papier') {
          return 'nette'
        }
        //customerIdentifier = customerIdentifier.replace("-", "")

        return customerIdentifier
      },
      updateCurrent (project) {
        project.loading = true
        Api.updateCurrent(project.identifier).then((status) => {
          project.status = status
          project.loading = false
        }).catch((err) => {
          if (err === 'FAILD') {
            project.loading = false
          } else if (err === 'UNAUTHORIZED') {
            this.$router.push('/login')
          }
        })
      },
      updateNext (project) {
        if (confirm('Start Update?')) {
          project.loading = true
          Api.updateNext(project.identifier).then((status) => {
            project.status = status
            project.loading = false
          }).catch((err) => {
            if (err === 'FAILD') {
              project.loading = false
            } else if (err === 'UNAUTHORIZED') {
              this.$router.push('/login')
            }
          })
        }
      },
      deactivateMaintenanceMode (project) {
        project.loading = true
        Api.deactivateMaintenanceMode(project.identifier).then((status) => {
          project.status = status
          project.loading = false
        }).catch((err) => {
          if (err === 'FAILD') {
            project.loading = false
          } else if (err === 'UNAUTHORIZED') {
            this.$router.push('/login')
          }
        })
      },
      deactivateCronPause (project) {
        project.loading = true
        Api.deactivateCronPause(project.identifier).then((status) => {
          project.status = status
          project.loading = false
        }).catch((err) => {
          if (err === 'FAILD') {
            project.loading = false
          } else if (err === 'UNAUTHORIZED') {
            this.$router.push('/login')
          }
        })
      }
    },
    computed: {
      unmergedProjects () {
        let out = []
        if (this.projects.length > 0) {
          for (let i = 0; i < this.projects.length; i++) {
            let project = this.projects[i]
            if (!project.status.isCurrentMergedInMaster && project.status.currentRedmineId > 0) {
              out.push(project)
            }
          }
        }

        return out
      }
    },
    data: function () {
      return {
        loading: false,
        hasError: false,
        projectsPerRow: 3,
        logs: [],
        projects: []
      }
    },
    mounted: function () {
      this.loading = true
      this.hasError = false

      Api.getAllProjects().then((projects) => {
        this.projects = projects
        this.loading = false
      }).catch((err) => {
        if (err === 'FAILD') {
          this.hasError = true
          this.loading = false
        } else if (err === 'UNAUTHORIZED') {
          this.$router.push('/login')
        }
      })

      Api.getLogs().then((logs) => {
        this.logs = logs
      }).catch((err) => {
        if (err === 'FAILD') {
        } else if (err === 'UNAUTHORIZED') {
          this.$router.push('/login')
        }
      })
    }
  }
</script>

<style scoped>
    .margin-top {
        margin-top: 1rem;
    }

    .margin-bottom {
        margin-bottom: 1rem;
    }

    .card-header h5 {
        margin-bottom: 0;
    }

    .card-body {
        min-height: 150px;
    }

    /*.project-content {*/
    /*min-height: 140px;*/
    /*}*/
</style>


// WEBPACK FOOTER //
// src/components/ProjectStatusPage.vue